import ExportForm from "../common/ExportForm";
import { WORK_EXPORT_COLUMNS } from "./actions_loaders";

export default function WorkExport() {
    return <ExportForm columns={WORK_EXPORT_COLUMNS} />;
}
